import { useState, useEffect } from 'react';
import { getCurrentTokenWithoutRedirect } from '@adsk/acs-sc-web-platform-api';

const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
};

const getOxygenId = (accessToken) => parseJwt(accessToken).userid;

const useOxygenId = () => {
  const [oxygenId, setOxygenId] = useState();
  const [error, setError] = useState(false);

  useEffect(() => {
    getCurrentTokenWithoutRedirect()
      .then(({ accessToken }) => {
        setOxygenId(getOxygenId(accessToken));
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('OxygenIdHook - Error fetching current oxygen ID', err);
        setError(true);
      });
  }, []);

  return { oxygenId, error };
};

export default useOxygenId;
